import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { conciergeAPI } from 'api/concierge';
import { setTestSession, show } from 'store/conciergeSlice';
import toast from 'app/toast';
import useBundleTranslation from 'i18n';

export interface IOpenTestSessionParams {
    modelObjectUid: string;
    elementId?: number;
    sessionLabel?: string;
}

export function useOpenTestSession() {
    const dispatch = useDispatch();
    const { t } = useBundleTranslation(['app/concierge/widget']);

    return useCallback(
        async ({ modelObjectUid, elementId, sessionLabel }: IOpenTestSessionParams): Promise<boolean> => {
            try {
                const session = await conciergeAPI.createTestSession({
                    model_object_uid: modelObjectUid,
                    element_id: elementId,
                    session_label: sessionLabel,
                });
                dispatch(setTestSession(session));
                dispatch(show());
                return true;
            } catch (error: any) {
                toast('error', error?.response?.data?.message ?? t('test_session.open_failed'));
                return false;
            }
        },
        [dispatch, t],
    );
}
